import axios from 'axios'

export const eventService = {
  events,
  tags,
  enrollment,
  removeEnrollment,
  confirmEnrollment,
  event,
  maxposti,
  removeEnrollmentByCode
}

function tags () {
  return axios.get('tags')
    .then(result => {
      return result.data
    })
}
function event (slug) {
  var me = this
  var url = 'sessionevento/' + slug

  return axios.get(url)
    .then(result => {
      return result.data
    }
    ).catch(function (error) {
      return error
    })
}
function events (tag, start, end, q) {
  var url = 'sessionevento/elenco/' + (tag || 'all')

  return axios.get(url, { params: { 'start': start || new moment().format('YYYY-MM-DD'), 'end': end || '9999-01-01', 'q': q || '' } })
    .then(result => {
      return result.data
    }
    )
}

function enrollment (enroll) {
  return axios.post('sessionevento/prenota', enroll)
    .then(result => {
      result.data.success = true
      result.data.errorMessage = ''
      result.data.lista = enroll.lista
      return result.data
    }
    ).catch(function (error) {
      error.success = false
      error.errorMessage = error.response.data.ExceptionMessage
      return error
    })
}

function maxposti (enroll) {
  return axios.get('sessionevento/prenota/max', { params: { id: enroll.id, email: enroll.email } })
    .then(result => {
      result.data.success = true
      result.data.errorMessage = ''
      return result.data
    }
    ).catch(function (error) {
      error.success = false
      error.errorMessage = error.response.data.ExceptionMessage
      return error
    })
}

function removeEnrollment (id) {
  return axios.delete('sessioneevento/cancella/' + id)
    .then(result => {
      return result.data
    }
    ).catch(function (error) {
      return error
    })
}

function removeEnrollmentByCode (request) {
  return axios.post('sessioneevento/cancellaprenotazione', request)
    .then(result => {
      return result.data
    }
    ).catch(function (error) {
      return error
    })
}

function confirmEnrollment (id) {
  return axios.get('sessioneevento/conferma/' + id)
    .then(result => {
      return result.data
    }
    ).catch(function (error) {
      return error
    })
}
